@defer (when vm) {
  <svg class="ngflowchart-arrow" xmlns="http://www.w3.org/2000/svg"
       [ngStyle]="{
         height: vm.containerHeight() + 'px',
         left: vm.containerLeft() + 'px',
         opacity: vm.opacity(),
         top: vm.containerTop() + 'px',
         width: vm.containerWidth() + 'px'
       }">
    <defs>
      <marker id="arrowhead" fill="grey" markerHeight="5" markerWidth="5" orient="auto" refX="3" refY="5"
              viewBox="0 0 10 10">
        <path d="M 0 0 L 10 5 L 0 10 z" />
      </marker>
    </defs>
    <g fill="none" id="arrowpath" marker-end="url(#arrowhead)" stroke="grey" stroke-width="2">
      <path #arrow id="arrow" />
    </g>
  </svg>
}
